import { useState, useCallback } from 'react';

/**
 * Custom hook that manages addon-related state and simple helpers.
 * Extracts ~7 useState variables from Admin.js.
 *
 * @returns {object} Addon state, setters, and utility methods
 */
export default function useAddonManager() {
  const [addonModalItem, setAddonModalItem] = useState(null);
  const [addonsList, setAddonsList] = useState([]);
  const [addonsLoading, setAddonsLoading] = useState(false);
  const [addonFormOpen, setAddonFormOpen] = useState(false);
  const [addonFormEditing, setAddonFormEditing] = useState(null);
  const [addonDeleteConfirmOpen, setAddonDeleteConfirmOpen] = useState(false);
  const [addonDeleteConfirmId, setAddonDeleteConfirmId] = useState(null);

  /** Close the addon management modal and reset related state */
  const closeAddonModal = useCallback(() => {
    setAddonModalItem(null);
    setAddonsList([]);
    setAddonFormOpen(false);
    setAddonFormEditing(null);
    setAddonDeleteConfirmOpen(false);
    setAddonDeleteConfirmId(null);
  }, []);

  /** Open the delete-confirmation dialog for a specific addon */
  const confirmDeleteAddon = useCallback((addonId) => {
    setAddonDeleteConfirmId(addonId);
    setAddonDeleteConfirmOpen(true);
  }, []);

  /** Close the delete-confirmation dialog */
  const cancelDeleteAddon = useCallback(() => {
    setAddonDeleteConfirmOpen(false);
    setAddonDeleteConfirmId(null);
  }, []);

  return {
    addonModalItem, setAddonModalItem,
    addonsList, setAddonsList,
    addonsLoading, setAddonsLoading,
    addonFormOpen, setAddonFormOpen,
    addonFormEditing, setAddonFormEditing,
    addonDeleteConfirmOpen, setAddonDeleteConfirmOpen,
    addonDeleteConfirmId, setAddonDeleteConfirmId,
    closeAddonModal,
    confirmDeleteAddon,
    cancelDeleteAddon,
  };
}
